"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import type { PlatformScope } from "@/domain/scope/platform-scope";
import type { SetupGateDecision } from "@/entities/billing/model/setup-gate";
import { AppLoading } from "@/components/ui/app-loading";
import { SetupPendingPage } from "./setup-pending-page";
interface SetupFloorGateProps {
  /** Identity, the super-admin skip or the gate status is not settled yet. */
  readonly unresolved: boolean;
  readonly decision: SetupGateDecision;
  readonly scope: PlatformScope;
  readonly children: ReactNode;
}

/**
 * A setup floor (spec underwriter/2026-10-17-001 R7, D29, G42) paints its
 * children while anything is unresolved: no spinner on a Free organisation's
 * navigation, and a failed read fails open (R7 AC8, D11). No other wall runs
 * here.
 */
export function SetupFloorGate(t0) {
  const $ = _c(5);
  const {
    unresolved,
    decision,
    scope,
    children
  } = t0;
  if (unresolved || decision === "pass") {
    let t1;
    if ($[0] !== children) {
      t1 = <>{children}</>;
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== decision || $[3] !== scope) {
    t1 = decision === "redirect" ? <AppLoading message="Redirecting..." /> : <SetupPendingPage scope={scope} />;
    $[2] = decision;
    $[3] = scope;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}